module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 1